import { USD } from "constants/currency";
import { currency } from "utils/Currency";

// Two formats are supported:
// 1. UNIT - $1234.56
// 2. STRING - 1234.56 USD - This format will be used for non-USD currencies

export const AmountSuperScript = ({
  amount,
  currencyCode = USD,
  noDecimal = false,
}: {
  amount: number;
  currencyCode?: string | null;
  noDecimal?: boolean;
}) => {
  const numberFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode || USD,
  });
  const currencyAmount = numberFormat.formatToParts(amount || 0);
  const fraction = currencyAmount.filter(({ type }) => type === "fraction");
  const { value: decimal } = fraction?.[0] || {};
  const localAmount =
    (amount || 0) > 0 ? Math.floor(amount) : Math.ceil(amount || 0);

  const numberToShow = currency({
    amount: localAmount,
    currencyCode: currencyCode,
    maximumFractionDigits: 0,
  });

  return (
    <span className="t-text-nowrap">
      <span className="t-sr-only">{`${numberToShow}.${decimal}`}</span>
      <span aria-hidden>{numberToShow}</span>
      {!noDecimal && (
        <sup aria-hidden className="-t-top-[0.2em] t-no-underline">
          .{decimal}
        </sup>
      )}
    </span>
  );
};
